"use client";
import { useState } from "react";

import Image from "next/image";

import {
  ButtonComponent,
  ModalComponent,
  TextFieldComponent,
} from "@/components";
import { IMAGES, MOBILE_REGEX, WEB_COLORS } from "@/lib/constants";
import { Button, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

const InvalidPhoneModal = ({
  onSkip,
  ckycPhoneFormik,
  handleCkycFieldChange,
  showInvalidPhoneModal,
  setShowInvalidPhoneModal,
  ckycAttemptsLeft,
}) => {
  const [chooseToSkip, setChooseToSkip] = useState(false);
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ModalComponent
      open={showInvalidPhoneModal}
      handleModal={setShowInvalidPhoneModal}
      maxWidth="md"
    >
      {!chooseToSkip ? (
        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          <Stack
            bgcolor={WEB_COLORS.pale}
            justifyContent={"center"}
            alignItems={"center"}
            p={2}
            gap={2}
            borderRadius={2}
          >
            <Image src={IMAGES.panMismatch} width={isBelowMd ? 180 : "100%"} />
          </Stack>
          <Stack spacing={3} mx={2}>
            <Typography
              fontWeight={700}
              fontSize={{ xs: 18, sm: 24 }}
              color={WEB_COLORS.primary}
            >
              Your mobile number does not match the CKYC records
            </Typography>
            <Typography color={WEB_COLORS.fadeColor}>
              Please enter the number linked to your CKYC
            </Typography>
            <TextFieldComponent
              shrink
              type="number"
              name="phone"
              maxLength={10}
              label={"Phone Number"}
              placeholder={"Enter phone number"}
              onBlur={ckycPhoneFormik.handleBlur}
              value={ckycPhoneFormik?.values?.phone}
              onChange={(e) => {
                handleCkycFieldChange(e, MOBILE_REGEX);
              }}
              error={
                ckycPhoneFormik.touched.phone &&
                Boolean(ckycPhoneFormik.errors.phone)
              }
              errorMessage={ckycPhoneFormik.errors.phone}
            />
            {ckycAttemptsLeft > 0 && (
              <Typography variant="subtitle2" color={WEB_COLORS.fadeColor}>
                You have {ckycAttemptsLeft} attempts remaining
              </Typography>
            )}
            <ButtonComponent onClick={ckycPhoneFormik.handleSubmit}>
              Verify Now
            </ButtonComponent>
            <Button
              variant="text"
              sx={{ textTransform: "capitalize" }}
              onClick={() => {
                setChooseToSkip(true);
              }}
            >
              Skip
            </Button>
          </Stack>
        </Stack>
      ) : (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={6}
            display={"flex"}
            bgcolor={WEB_COLORS.pale}
            justifyContent={"center"}
            alignItems={"center"}
            p={2}
            gap={2}
            borderRadius={2}
          >
            <Image src={IMAGES.skipCkyc} alt="Skip CKYC" />
          </Grid>
          <Grid item xs={12} md={6} sx={{ alignSelf: "center" }}>
            <Stack spacing={3}>
              <Typography
                fontWeight={700}
                fontSize={{ xs: 18, sm: 24 }}
                color={WEB_COLORS.primary}
              >
                Are you sure?
              </Typography>
              <Typography color={WEB_COLORS.fadeColor} variant="caption" my={2}>
                If skipped, Aadhaar-based KYC will be required at a later stage.
              </Typography>
              <ButtonComponent type="submit" onClick={onSkip}>
                Proceed Anyway
              </ButtonComponent>
              <ButtonComponent
                type="reset"
                variant="outlined"
                onClick={() => setChooseToSkip(false)}
              >
                Go Back
              </ButtonComponent>
            </Stack>
          </Grid>
        </Grid>
      )}
    </ModalComponent>
  );
};

export default InvalidPhoneModal;
